import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgxMaskModule } from 'ngx-mask';

import { DashboardRoutingModule } from './dashboard-routing.module';

import { NFSeComponent } from './components/nfse/nfse.component';
import { DashboardComponent } from './dashboard.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { BoletosComponent } from './components/boletos/boletos.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { RemessaComponent } from './components/boletos/remessa/remessa.component';
import { RetornoComponent } from './components/boletos/retorno/retorno.component';
import { ClienteComponent } from './components/clientes/cliente/cliente.component';
import { TransacoesComponent } from './components/transacoes/transacoes.component';
import { VisaoGeralComponent } from './components/visao-geral/visao-geral.component';
import { MinhaContaComponent } from './components/minha-conta/minha-conta.component';
import { ClientesComponent } from './components/clientes/clientes/clientes.component';
import { DatepickerComponent } from '../../shared/components/datepicker/datepicker.component';
import { ModalDetailComponent } from '../../shared/components/modal-detail/modal-detail.component';
import { ConfiguracoesComponent } from './components/minha-conta/configuracoes/configuracoes.component';
import { CardGeralComponent } from './components/minha-conta/configuracoes/card-geral/card-geral.component';
import { CardCedenteComponent } from './components/minha-conta/configuracoes/card-cedente/card-cedente.component';
import { CardAdquirenteComponent } from './components/minha-conta/configuracoes/card-adquirente/card-adquirente.component';
import { CardAlterarSenhaComponent } from './components/minha-conta/configuracoes/card-alterar-senha/card-alterar-senha.component';

import { NFSeService } from '../../shared/services/nfse/nfse.service';
import { AdminService } from '../../shared/services/admin/admin.service';
import { ContaService } from '../../shared/services/conta/conta.service';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { LoginService } from '../../shared/services/auth/login/login.service';
import { RemessaService } from '../../shared/services/remessa/remessa.service';
import { RetornoService } from '../../shared/services/retorno/retorno.service';
import { CedenteService } from '../../shared/services/cedente/cedente.service';
import { AdquirenteService } from '../../shared/services/adquirente/adquirente.service';
import { AuthGuardService } from '../../shared/services/auth-guard/auth-guard.service';
import { ErrorReportingService } from '../../shared/services/error-reporting/error-reporting.service';
import { ProximasTransacoesComponent } from './components/proximas-transacoes/proximas-transacoes.component';
import { TodosBoletosComponent } from './components/boletos/todos-boletos/todos-boletos.component';
import { BoletoService } from '../../shared/services/boleto/boleto.service';
import { CobrancaService } from '../../shared/services/cobranca/cobranca.service';
import { RegisterComponent } from '../../shared/components/register/register.component';
import { CriarSenhaService } from '../../shared/services/auth/criar-senha/criar-senha.service';
import { CadastroService } from '../../shared/services/auth/cadastro/cadastro.service';
import { LancamentosFuturosComponent } from './components/minha-conta/lancamentos-futuros/lancamentos-futuros.component';
import { AgendaFinanceiraComponent } from './components/agenda-financeira/agenda-financeira.component';
import { AgendasService } from '../../shared/services/agendas/agendas.service';
import { VendasComponent } from './components/vendas/vendas.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    DashboardRoutingModule,
    FormsModule,
    DirectivesModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    NFSeComponent,
    NavbarComponent,
    FooterComponent,
    VendasComponent,
    BoletosComponent,
    RemessaComponent,
    ClienteComponent,
    RetornoComponent,
    RegisterComponent,
    ClientesComponent,
    SideMenuComponent,
    CardGeralComponent,
    DashboardComponent,
    TransacoesComponent,
    MinhaContaComponent,
    VisaoGeralComponent,
    DatepickerComponent,
    CardCedenteComponent,
    TodosBoletosComponent,
    ConfiguracoesComponent,
    CardAdquirenteComponent,
    CardAlterarSenhaComponent,
    AgendaFinanceiraComponent,
    ProximasTransacoesComponent,
    LancamentosFuturosComponent,
  ],
  providers: [
    NFSeService,
    AdminService,
    ContaService,
    LoginService,
    BoletoService,
    CedenteService,
    RemessaService,
    RetornoService,
    AgendasService,
    CobrancaService,
    CadastroService,
    AuthGuardService,
    AdquirenteService,
    CriarSenhaService,
    ErrorReportingService,
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.module.ts